import React, { useState, useCallback, useMemo, useEffect } from 'react';
import Select from 'react-select';
import { IParteProcesso, PartesEnvolvidasProps, QUALIFICACOES } from '../types';
import { IconTrash } from '../../../icons';
import {
  Label,
  Input,
  AddButton,
  FieldRow,
  List,
  ListItem,
  CustomCheckbox,
  CheckboxLabel,
  DeleteButton,
  ErrorText,
  Tag,
  selectStyles,
  selectTheme,
  selectComponents
} from './styles';

const MAX_NOME = 200;

const PartesEnvolvidas: React.FC<PartesEnvolvidasProps> = ({ partes, onChange, erros }) => {
  const [qualificacao, setQualificacao] = useState<string>('');
  const [nome, setNome] = useState<string>('');

  // Opções para o select de qualificação
  const opcoesQualificacao = useMemo(() => 
    QUALIFICACOES.map(q => ({ value: q, label: q })),
    []
  );

  const podeAdicionar = useMemo(() => qualificacao.trim() && nome.trim(), [qualificacao, nome]);

  const adicionarParte = useCallback(() => {
    if (!podeAdicionar) return;
    const novaParte: IParteProcesso = { tipo: qualificacao, nome: nome.trim(), representada: false };
    const novas = [...partes, novaParte];
    onChange(novas);
    setNome('');
  }, [podeAdicionar, qualificacao, nome, partes, onChange]);

  const alternarRepresentada = useCallback((index: number) => {
    const novas = partes.map((p, i) => i === index ? { ...p, representada: !p.representada } : p);
    onChange(novas);
  }, [onChange, partes]);

  const removerParte = useCallback((index: number) => {
    const novas = partes.filter((_, i) => i !== index);
    onChange(novas);
  }, [onChange, partes]);

  return (
    <div>
      <FieldRow>
        <div>
          <Label>
            Qualificação
          </Label>
          <Select
            name="qualificacao"
            styles={selectStyles}
            components={selectComponents}
            theme={selectTheme}
            placeholder="Selecionar tipo"
            value={opcoesQualificacao.find(option => option.value === qualificacao)}
            onChange={(selected: any) => setQualificacao(selected?.value || '')}
            options={opcoesQualificacao}
          />
        </div>
        <div>
          <Label>
            Nome da Parte
          </Label>
          <Input
            value={nome}
            placeholder="Digite o nome da parte"
            maxLength={MAX_NOME}
            onChange={e => setNome(e.target.value)}
          />
          {erros?.partes?.nome && <ErrorText>{erros.partes.nome}</ErrorText>}
        </div>
        <div>
          <AddButton
            disabled={!podeAdicionar}
            title={!podeAdicionar ? 'Preencha as informações da parte para adicioná-la' : ''}
            onClick={adicionarParte}
          >
            + Adicionar
          </AddButton>
        </div>
      </FieldRow>

      <List style={{ marginTop: 12 }}>
        {partes.map((p, index) => (
          <ListItem key={`${p.tipo}-${p.nome}-${index}`}>
            <div>
              <span style={{ fontWeight: 'bold', color: 'var(--c2d3748)' }}>{p.tipo}:</span>{' '}
              <span style={{ color: 'var(--c2d3748)' }}>{p.nome}</span>
            </div>
            <div>
              <CheckboxLabel onClick={() => alternarRepresentada(index)}>
                <CustomCheckbox checked={p.representada} />
                <span>Representada</span>
              </CheckboxLabel>
            </div>
            <div>
              <DeleteButton onClick={() => removerParte(index)}>
                <IconTrash />
              </DeleteButton>
            </div>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default PartesEnvolvidas;


